export default [
  {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Analytics.vue'),
    meta: {
      resource: 'Dash',
      action: 'read',
    },
  },
  {
    path: '/dashboard/ecommerce',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
    meta: {
      resource: 'Dash',
      action: 'read',
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard-coparate',
    component: () => import('@/views/dashboard/coparate/Coparate.vue'),
    meta: {
      resource: 'Dash',
      action: 'read',
    },
  },
]
